import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $tick = _ref.$tick,
      $f7 = _ref.$f7;
  var page_name = 'nvut-loinhac-popup';
  var form_name = 'loinhac-form';
  var pn = ".".concat(page_name);
  var rows = [],
      row = null;

  var save = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newrow, rs, i, _rs;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newrow = $f7.form.convertToData($('.' + form_name));

              if (!row) {
                _context.next = 9;
                break;
              }

              //edit
              newrow.id = row.id;
              _context.next = 5;
              return Base.call({
                method: '_put',
                table: 'nvut_tieuchi',
                params: newrow
              });

            case 5:
              rs = _context.sent;

              for (i = 0; i < rows.length; i++) {
                if (rows[i].id === rs.row.id) {
                  rows[i] = rs.row;
                }
              }

              _context.next = 13;
              break;

            case 9:
              _context.next = 11;
              return Base.call({
                method: '_post',
                table: 'nvut_tieuchi',
                params: newrow
              });

            case 11:
              _rs = _context.sent;
              rows.push(_rs.row);

            case 13:
              $f7.toast.create({
                text: 'Lưu lại thành công',
                closeTimeout: 1500,
                position: 'top'
              }).open();
              row = null;
              $update(function () {
                $('.' + form_name).find('input').val('');
                $('.' + form_name).find('textarea').val('');
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function save() {
      return _ref2.apply(this, arguments);
    };
  }();

  var edit = function edit(e) {
    var id = parseInt($(e.target).closest('tr').data('id'));
    row = rows.find(function (r) {
      return r.id === id;
    });
    $f7.form.fillFromData($('.' + form_name), row);
    $('.page-content').scrollTop(0);
  };

  var remove = function remove(e) {
    var id = parseInt($(e.target).closest('tr').data('id'));
    $f7.dialog.confirm('Xác nhận xoá?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Base.call({
                method: '_softDelete',
                table: 'nvut_tieuchi',
                params: {
                  id: id
                }
              });

            case 2:
              rs = _context2.sent;
              rows = rows.filter(function (r) {
                return r.id !== id;
              });
              $update();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
  };

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Base.call({
              method: '_get',
              table: 'nvut_tieuchi',
              params: {
                order: 'id',
                where: 'deleted_at IS NULL'
              }
            });

          case 2:
            rs = _context3.sent;
            rows = rs.rows;
            $update();

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }))();

  $tick(function () {});
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup ${page_name}" data-name="${page_name}">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Quản lý lời nhắc</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".${page_name}"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">
          <div class="list no-margin ${form_name}">
            <ul>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Nội dung nhắc nhở</div>
                  <div class="item-input-wrap">
                    <textarea name="name"></textarea>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Số tiền</div>
                  <div class="item-input-wrap">
                    <input type="text" name="so_tien" />
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <button class="button" @click="${save}">Lưu lại</button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          
          <div class="block-title margin-half">Nhân viên KHÔNG:</div>
    
          <div class="data-table">
            <table>
              <thead>
                <tr>
                  <th>Nội dung</th>
                  <th>Số tiền</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                ${rows.length > 0 && rows.map(row=>$h`
                  <tr key="${row.id}" data-id="${row.id}">
                    <td><a @click="${edit}">${row.name}</a></td>
                    <td>${Utils.num2Str(row.so_tien)}</td>
                    <td><a @click="${remove}"><i class="icon f7-icons">multiply</i></a></td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>
    
        </div>

      </div>
    </div>
  </div>
`
    }
    ;
});